import { Component, EventEmitter, OnChanges, OnInit, OnDestroy, SimpleChanges, Input, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import lodashClonedeep from 'lodash.clonedeep';
import moment from "moment";
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { SkuDeepdiveHelper } from 'src/app/components/pages/sku-deepdive/sku-deepdive-helper';
import { AreaDeepdiveHelper } from '../../pages/area-deepdive/area-deepdive-helper';
import { HQProgressHelper } from 'src/app/components/pages/hq-progress/hq_progress_helper';
import { DistrictRouterProgressHelper } from 'src/app/components/pages/district-route-progress/district_route_progress_helper';
import { ProgressRankingHelper } from 'src/app/components/pages/progress-ranking/progress-ranking-helper';

import { SkuRankingHelper } from 'src/app/components/pages/sku-ranking/sku-ranking-helper';
import { FaceShareHelper } from 'src/app/components/pages/faceshare/faceshare.helper';
import { PocHelper } from 'src/app/components/pages/poc/poc.helper';
import { SalesDateTagHelper } from './helper-tag';
import { SalesDateTagService } from './sales-date-filter-tag.service';
import { MixPanelTrackingService } from 'src/app/services/mixpanel-tracking.services';

@Component({
  selector: 'sales-date-filter-tag',
  templateUrl: './sales-date-filter-tag.component.html',
  styleUrls: ['./sales-date-filter-tag.component.scss']
})

export class SalesDateTagComponent implements OnInit, OnDestroy {
  @Input() pageName: string = '';
  @Output() onDateTypeSaveItemsChange = new EventEmitter<{ selectedDateType: string, selectedSalesDate: string[], isTracking?: boolean }>();
  private salesDateSubscription: Subscription;

  lstOption_DateType: any = [];
  lstOption_Selected_DateType: any = '';
  lstOption_Aggregated_DateType: any = '';

  lstOption_SalesDate$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  lstOption_Selected_SalesDate$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  lstOption_Week: any = [];
  lstOption_FromTo: any = [];
  lstOption_From: any = [];
  lstOption_To: any = [];
  lstOption_Selected_From: string = '';
  lstOption_Selected_To: string = '';
  lstOption_Aggregated_From: string = '';
  lstOption_Aggregated_To: string = '';
  lstOption_Aggregated: any = [];


  // For SkuRanking filtering

  rawSalesDateWeek: any[] = [];
  filteredSalesDateWeek: { value: string, name: string }[] = [];

  dailySalesDateRange: any = {
    ready: false,
    fromDate: null,
    toDate: null,
    maxDate: null,
    minDate: null,
    previousFromDate: null,
    previousToDate: null
  }

  isCalendar: boolean = false;
  isFromToDropdown: boolean = false;
  isSingleMonthDropdown: boolean = false;
  isMultiMonthsDropdown: boolean = false;
  isSingleDateDropdown: boolean = false;
  isOnlyView: boolean = true;
  dailySalesDate: string = '';

  sePaths = ['/hq-progress', '/district-route-progress', '/sku-deepdive', '/area-deepdive', '/progress-ranking'];
  traxPaths = ['/sovi', '/poc'];
  skuRankingPaths = ['/sku-ranking'];

  constructor(private salesDateTagService: SalesDateTagService, private mixPanelTrackingService: MixPanelTrackingService) { }

  ngOnInit() {
    if (this.isCurrentPathIncluded(this.sePaths)) {
      this.salesDateSubscription = this.salesDateTagService.getSESalesDate().subscribe((date: string[]) => {
        if (date && date.length > 0) {
          this.dailySalesDate = date[0] || '';
          this._initSalesDateOptions();
        }
      });

      this.salesDateTagService.getSEDateInJobClearCache();
    }

    if (this.isCurrentPathIncluded(this.traxPaths)) {
      this.salesDateSubscription = this.salesDateTagService.getTraxSalesDate().subscribe((date: string[]) => {
        if (date && date.length > 0) {
          this.dailySalesDate = date[0] || '';
          this._initSalesDateOptions();
        }
      });

      this.salesDateTagService.getTraxDateInJobClearCache();
    }

    if (this.isCurrentPathIncluded(this.skuRankingPaths)) {
      this.salesDateSubscription = this.salesDateTagService.getSkuRankingSalesDate().subscribe((date: string[]) => {
        if (date && date.length > 0) {
          this.dailySalesDate = date[0] || '';
          this._initSalesDateOptions();
        }
      });
      this.salesDateTagService.getSkuRankingDateInJobClearCache();
    }
  }

  ngOnDestroy() {
    if (this.salesDateSubscription) {
      this.salesDateSubscription.unsubscribe();
    }
  }

  public onDateTypeSave = (rollBack: boolean) => {
    if (!rollBack) {
      this.lstOption_Aggregated_DateType = lodashClonedeep(this.lstOption_Selected_DateType);
      if (this.pageName === 'SkuRanking') {
        this.updateFilteredSalesDateWeek(this.lstOption_Aggregated_DateType);

      }
      this._setOptionsSaleDate();
      this._emitDataToParent();
    } else {
      this.lstOption_Selected_DateType = lodashClonedeep(this.lstOption_Aggregated_DateType);
    }
  }

  public onFromToDropdownSave = (rollBack: boolean, dropdownType: string) => {
    if (!rollBack) {
      if (dropdownType === 'from') {
        this.lstOption_Aggregated_From = this.lstOption_Selected_From;
        this.updateFilteredToArray();
      }

      if (dropdownType === 'to') {
        this.lstOption_Aggregated_To = this.lstOption_Selected_To;
        this.updateFilteredFromArray();
      }

      this._emitDataToParent();
    } else {
      if (dropdownType === 'from') {
        this.lstOption_Selected_From = this.lstOption_Aggregated_From;
      }

      if (dropdownType === 'to') {
        this.lstOption_Selected_To = this.lstOption_Aggregated_To;
      }
    }
  }

  public onSalesDateSaveItemsChange(e: any) {
    const { selectedItems } = e;

    this.lstOption_Selected_SalesDate$.next([...selectedItems]);
    this._emitDataToParent();
  }

  public onSalesDateModelChange(event: any): void {
    this.lstOption_Selected_SalesDate$.next([...event]);
    this._emitDataToParent();
  }

  public onMultiDropdownSaveItemsChange(event: any): void {
    const { selectedItems } = event;
    this.lstOption_Selected_SalesDate$.next([...selectedItems]);
    this._emitDataToParent();
    this.onTrackDropdownAggregate('Period', selectedItems);
  }

  public onSingSalesDateSaveItemsChange(e: string) {
    this.lstOption_Selected_SalesDate$.next([e]);
    this._emitDataToParent();
  }

  public onMultiSalesDateSaveItemsChange(e: string) {
    this.lstOption_Selected_SalesDate$.next([e]);
    this._emitDataToParent();
  }

  public onDateSelect(value: any) {
    if (value) {
      const { from, to } = value;

      if (from && to) {
        const startDate = moment(new Date(from)).format("YYYY-MM-DD");
        const endDate = moment(new Date(to)).format("YYYY-MM-DD");

        //if (!moment(startDate).isSame(this.dailySalesDateRange.previousFromDate) || !moment(endDate).isSame(this.dailySalesDateRange.previousToDate)) {
        this.onDateTypeSaveItemsChange.emit({
          selectedDateType: this.lstOption_Aggregated_DateType,
          selectedSalesDate: [startDate, endDate],
          isTracking: true
        });
        // }
      }
    }
  }

  private _initSalesDateOptions() {
    switch (this.pageName) {
      case 'HQProgress':
        HQProgressHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        });
        break;

      case 'DistrictRouterProgress':
        DistrictRouterProgressHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        });
        break;

      case 'ProgressRanking':
        ProgressRankingHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        });
        break;

      case 'SkuDeepdive':
        SkuDeepdiveHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        });
        break;
      case 'AreaDeepdive':
        AreaDeepdiveHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        })
        break;
      case 'FaceShare':
        FaceShareHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        });
        break;

      case 'PoC':
        PocHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        });
        break;
      case 'SkuRanking':
        SkuRankingHelper.getSalesDate().subscribe((salesDate: string[]) => {
          if (salesDate && salesDate.length > 0) {
            this.lstOption_DateType = salesDate.map((item: string) => { return { value: item, text: item }; });
            this._setOptionsSaleDate(true);
            this.onDateTypeSave(false);
          }
        });
        SkuRankingHelper.getSalesDateWeek().subscribe((salesDateWeek: any[]) => {
          if (salesDateWeek && salesDateWeek.length > 0) {
            this.rawSalesDateWeek = salesDateWeek;
            this.updateFilteredSalesDateWeek('Week');
            this._setOptionsSaleDate();
          } else {
            this.rawSalesDateWeek = [];
            this.filteredSalesDateWeek = [];
            this._setOptionsSaleDate();
          }
        });
        break;
      default:
        break;
    }
  }

  private _emitDataToParent() {
    if (this.isCalendar) {
      this.onDateTypeSaveItemsChange.emit({
        selectedDateType: this.lstOption_Aggregated_DateType,
        selectedSalesDate: this.lstOption_Selected_SalesDate$.value
      });
    }

    if (this.isFromToDropdown) {
      switch (this.lstOption_Selected_DateType) {
        case 'Specific Month':
        case 'YTD':
        case 'QTD':
          if (this.pageName === 'SkuDeepdive' || this.pageName === 'AreaDeepdive') {
            this.onDateTypeSaveItemsChange.emit({
              selectedDateType: this.lstOption_Aggregated_DateType,
              selectedSalesDate: [this.lstOption_Aggregated_From, this.lstOption_Aggregated_To]
            });
          } else {
            this.onDateTypeSaveItemsChange.emit({
              selectedDateType: this.lstOption_Aggregated_DateType,
              selectedSalesDate: SalesDateTagHelper.getMonthsInRangeByMonth(this.lstOption_Aggregated_From, this.lstOption_Aggregated_To)
            });
          }
          break;

        case 'MTD':
        case 'This Month':
          this.onDateTypeSaveItemsChange.emit({
            selectedDateType: this.lstOption_Aggregated_DateType,
            selectedSalesDate: [this.lstOption_Aggregated_From]
          });
          break;

        default:
          this.onDateTypeSaveItemsChange.emit({
            selectedDateType: this.lstOption_Aggregated_DateType,
            selectedSalesDate: [this.lstOption_Aggregated_From, this.lstOption_Aggregated_To]
          });
          break;
      }
    }

    if (this.isSingleMonthDropdown || this.isMultiMonthsDropdown) {
      switch (this.lstOption_Selected_DateType) {
        case 'MTD':
          this.onDateTypeSaveItemsChange.emit({
            selectedDateType: this.lstOption_Aggregated_DateType,
            selectedSalesDate: [...this.lstOption_Selected_SalesDate$.value]
          });
          break;

        default:
          break;
      }
    }

    if (this.isSingleDateDropdown) {
      let selectedPeriods = this.lstOption_Selected_SalesDate$.value;
      if (selectedPeriods.includes('All')) {
        selectedPeriods = this.lstOption_SalesDate$.value
          .filter(item => item.value !== 'All')
          .map(item => item.value);
      }
      this.onDateTypeSaveItemsChange.emit({
        selectedDateType: this.lstOption_Aggregated_DateType,
        selectedSalesDate: selectedPeriods
      });
    }
  }

  private _convertToNgbDateStruct(date: Date): NgbDateStruct {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }

  private _initOptionSaleDate(value1: string, value2: string, isInit: boolean) {
    const fromObj = new Date(value1);
    const toObj = new Date(value2);

    let todate = new Date(toObj.getFullYear(), toObj.getMonth(), toObj.getDate());
    let fromdate = new Date(fromObj.getFullYear(), fromObj.getMonth(), fromObj.getDate());
    this.dailySalesDateRange.toDate = todate;
    this.dailySalesDateRange.fromDate = fromdate;
    this.dailySalesDateRange.previousToDate = todate;
    this.dailySalesDateRange.previousFromDate = fromdate;

    if (isInit) {
      let maxDate = new Date(toObj.getFullYear(), toObj.getMonth(), toObj.getDate());
      let minDate = new Date(fromObj.getFullYear(), fromObj.getMonth(), fromObj.getDate());
      this.dailySalesDateRange.maxDate = this._convertToNgbDateStruct(maxDate);
      this.dailySalesDateRange.minDate = this._convertToNgbDateStruct(minDate);
    }

    this.dailySalesDateRange.ready = true;
  }

  private _setOptionsSaleDate(firstLoad: boolean = false) {
    if (firstLoad) {
      if (this.pageName === 'AreaDeepdive') {
        this.lstOption_Selected_DateType = this.lstOption_DateType[0].value;
        this.lstOption_Aggregated_DateType = this.lstOption_DateType[0].value;
      }
      else {
        this.lstOption_Selected_DateType = this.lstOption_DateType[0].value;
        this.lstOption_Aggregated_DateType = this.lstOption_DateType[0].value;
      }
    }

    this.isCalendar = SalesDateTagHelper.isShowCalendar(this.pageName, this.lstOption_Aggregated_DateType);
    this.isFromToDropdown = SalesDateTagHelper.isFromToDropdown(this.pageName, this.lstOption_Aggregated_DateType);
    this.isSingleMonthDropdown = SalesDateTagHelper.isPhotoReport(this.pageName, this.lstOption_Aggregated_DateType);
    this.isMultiMonthsDropdown = SalesDateTagHelper.isMultipleMonths(this.pageName, this.lstOption_Aggregated_DateType);
    this.isOnlyView = SalesDateTagHelper.isOnlyView(this.pageName, this.lstOption_Aggregated_DateType);
    this.isSingleDateDropdown = SalesDateTagHelper.isSingleDateDropdown(this.pageName, this.lstOption_Aggregated_DateType);
    if (this.pageName === 'SkuRanking' && this.isSingleDateDropdown && (!this.filteredSalesDateWeek || this.filteredSalesDateWeek.length === 0)) {
      this.updateFilteredSalesDateWeek(this.lstOption_Aggregated_DateType || 'Week');
    }
    if (this.isCalendar) {
      const dates = SalesDateTagHelper.getSalesDate(this.pageName, this.lstOption_Aggregated_DateType, this.dailySalesDate);

      if (dates && Array.isArray(dates) && dates.length >= 2) {
        this.dailySalesDateRange.ready = false;
        this._initOptionSaleDate(dates[0], dates[1], true);
        this.lstOption_Selected_SalesDate$.next([dates[0], dates[1]]);
      }
    }

    if (this.isFromToDropdown) {
      switch (this.lstOption_Aggregated_DateType) {
        case 'This Month':
        case 'MTD':
          const currentMonth = SalesDateTagHelper.getCurrentMonth(this.dailySalesDate);
          this.lstOption_From = [{ value: currentMonth, name: currentMonth }];
          this.lstOption_To = [{ value: currentMonth, name: currentMonth }];
          break;

        case 'QTD':
          this.lstOption_From = SalesDateTagHelper.getCurrentQuarterMonthsUntilYesterday(this.dailySalesDate);
          this.lstOption_To = SalesDateTagHelper.getCurrentQuarterMonthsUntilYesterday(this.dailySalesDate);
          break;

        case 'YTD':
          this.lstOption_From = SalesDateTagHelper.getMonthsUntilYesterday(this.dailySalesDate);
          this.lstOption_To = SalesDateTagHelper.getMonthsUntilYesterday(this.dailySalesDate);
          break;

        default:
          this.lstOption_FromTo = SalesDateTagHelper.getMonthsUntilYesterday(this.dailySalesDate);
          this.lstOption_From = [...this.lstOption_FromTo];
          this.lstOption_To = [...this.lstOption_FromTo];
          break;
      }

      this.lstOption_Selected_From = this.lstOption_From[0]?.value || '';
      this.lstOption_Selected_To = this.lstOption_From[this.lstOption_From.length - 1]?.value || '';
      this.lstOption_Aggregated_From = this.lstOption_From[0]?.value || '';
      this.lstOption_Aggregated_To = this.lstOption_From[this.lstOption_From.length - 1]?.value || '';
    }


    if (this.isSingleMonthDropdown || this.isMultiMonthsDropdown || this.isSingleDateDropdown) {

      const months = this.isSingleMonthDropdown ? [...SalesDateTagHelper.getPhotoReportMonths(this.pageName)] : [...SalesDateTagHelper.getLatest13Months(this.dailySalesDate)];

      if (months && Array.isArray(months) && months.length > 0) {
        this.lstOption_SalesDate$.next(months);
        this.lstOption_Selected_SalesDate$.next([months[0].value]);
      }
    }

    if (this.isSingleDateDropdown) {
      if (this.pageName === 'SkuRanking') {
        if (this.filteredSalesDateWeek && this.filteredSalesDateWeek.length > 0) {
          const validItems = this.filteredSalesDateWeek
            .filter(item => item && item.value)
            .map(item => ({ value: item.value, text: item.name || item.value }));
          const itemsWithAll = [{ value: 'All', text: 'All' }, ...validItems];
          this.lstOption_SalesDate$.next(itemsWithAll);
          this.lstOption_Selected_SalesDate$.next([this.lstOption_SalesDate$.value[this.lstOption_SalesDate$.value.length - 1].value]);
        } else {
          this.lstOption_SalesDate$.next([]);
          this.lstOption_Selected_SalesDate$.next([]);
        }
      } else {
        const listOptions = [...SalesDateTagHelper.getListOptions(this.pageName, this.dailySalesDate)];
        if (listOptions && Array.isArray(listOptions) && listOptions.length > 0) {
          const validItems = listOptions
            .filter(item => item && item.value)
            .map(item => ({ value: item.value, text: item.name || item.value }));
          const itemsWithAll = [{ value: 'All', text: 'All' }, ...validItems];
          this.lstOption_SalesDate$.next(itemsWithAll);
          this.lstOption_Selected_SalesDate$.next(['All']);
        } else {
          this.lstOption_SalesDate$.next([]);
          this.lstOption_Selected_SalesDate$.next([]);
        }
      }
      if (firstLoad && this.isSingleDateDropdown) {
        setTimeout(() => {
          this._emitDataToParent();
        }, 100);
      }
    }
  }

  private updateFilteredFromArray() {
    if (this.lstOption_Aggregated_From) {
      this.lstOption_From = [...this.lstOption_FromTo].filter(date => date.value <= this.lstOption_Aggregated_To);
    } else {
      this.lstOption_From = [...this.lstOption_FromTo];
    }
  }

  private updateFilteredToArray() {
    if (this.lstOption_Aggregated_To) {
      this.lstOption_To = [...this.lstOption_FromTo].filter(date => date.value >= this.lstOption_Aggregated_From);
    } else {
      this.lstOption_To = [...this.lstOption_FromTo];
    }
  }

  private isCurrentPathIncluded(paths: string[]): boolean {
    return paths.some(path => location.href.includes(path));
  }

  public onTrackDropdownAggregate(filterName: string, selectedItems: string[]) {
    this.mixPanelTrackingService.onTrackDropdownAggregate('', filterName, selectedItems);
  }
  

  private updateFilteredSalesDateWeek(selectedDateType: string) {
    if (this.rawSalesDateWeek && this.rawSalesDateWeek.length > 0) {
      this.filteredSalesDateWeek = SkuRankingHelper.filterAndFormatSalesDateWeek(
        this.rawSalesDateWeek,
        selectedDateType
      );
      if (this.pageName === 'SkuRanking' && this.isSingleDateDropdown) {
        if (this.filteredSalesDateWeek && this.filteredSalesDateWeek.length > 0) {
          // Format for multi-dropdown and add "All" option
          const validItems = this.filteredSalesDateWeek
            .filter(item => item && item.value)
            .map(item => ({ value: item.value, text: item.name || item.value }));
          const itemsWithAll = [{ value: 'All', text: 'All' }, ...validItems];
          this.lstOption_SalesDate$.next(itemsWithAll);
          this.lstOption_Selected_SalesDate$.next([this.lstOption_SalesDate$.value[this.lstOption_SalesDate$.value.length-1].value]);
        } else {
          this.lstOption_SalesDate$.next([]);
          this.lstOption_Selected_SalesDate$.next([]);
        }
      }
    } else {
      this.filteredSalesDateWeek = [];
      if (this.pageName === 'SkuRanking' && this.isSingleDateDropdown) {
        this.lstOption_SalesDate$.next([]);
        this.lstOption_Selected_SalesDate$.next([]);
      }
    }
  }
  public onSkuRankingDateTypeChange(selectedDateType: string) {
    this.updateFilteredSalesDateWeek(selectedDateType);
    // Emit the selected values to parent component
    this.onDateTypeSaveItemsChange.emit({
      selectedDateType: selectedDateType,
      selectedSalesDate: this.filteredSalesDateWeek.map(item => item.value)
    });
  }
}
